import { useRecoilValue } from 'recoil';

import { CountryFlag } from '@/components/country-flag';
import { Heading } from '@/components/heading';
import { Text } from '@/components/text';
import { getLocationByIdState } from '@/state/locations';
import { getPreferredIdentifier } from '@/utils/helpers';
import { tv } from '@/utils/styles';

export interface JourneyLegLocationProps {
  locationId: string;
}

const JourneyLegLocation = ({ locationId }: JourneyLegLocationProps) => {
  const location = useRecoilValue(getLocationByIdState(locationId));
  const identifier = getPreferredIdentifier(location.identifiers)?.value;

  const { text, heading, locationRow } = styles();

  return (
    <div>
      {identifier && (
        <Heading variant="h4" className={heading()}>
          {identifier}
        </Heading>
      )}
      <div className={locationRow()}>
        {location.countryCode && <CountryFlag countryCode={location.countryCode} className="h-3" />}
        <Text variant="secondary" className={text()}>
          {location.name}
        </Text>
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    text: 'm-0 text-sm font-normal leading-relaxed text-grey-600',
    subText: 'm-0 font-medium',
    heading: 'mb-0 font-semibold',
    locationRow: 'flex items-center gap-2',
  },
});

export { JourneyLegLocation };
